import { HideHubspotBubbleStyle } from '@components/HideHubspotBubbleStyle';
import { routesCollection } from '@containers/Routes';
import { UIShell } from '@packages/layout';
import { createMemo } from '@packages/react';
import { Route, Switch } from '@packages/router/lib/route';
import { UserView } from '@packages/user/lib/UserView';
import React from 'react';
import Error404 from './Errors/404';

/**
 * @author: Dumitrana Alinus <alin.desisgnstudio@gmail.com>
 * @class: Shell
 * @date:  29.08.2018
 * @time:  08:31
 * @scope:
 */
export const Shell = createMemo(
    () => (
        <UIShell>
            <Switch>
                {routesCollection}
                <Route path={'*'} component={Error404} />
            </Switch>
            <UserView view={'designer,admin,salesman'}>
                <HideHubspotBubbleStyle />
            </UserView>
        </UIShell>
    ),
    {
        displayName: 'Shell',
    },
);
